import { ColumnEditorOptions } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { ChangeEvent } from "react";

export const InputTextEditor = (options: ColumnEditorOptions) => {
    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (options.editorCallback) {
            options.editorCallback(event.target.value);
        }
    };

    return <InputText autoFocus value={options.value || ''} onChange={onChange} />;
};
